import { Component, OnInit } from '@angular/core';
import { UtilService } from '@app/core/services/utils/util.service';
import { SettingsService } from '@app/services/settings/settings.service';
import { billingRecord } from '../../../../services/settings/settings-dto';
import { historyColumns } from '../model';
import { camelCaseToTitleCase } from '@utils/string-utils';

export class SortField {
  public fieldName: string;
  public direction: 'ASC' | 'DESC' | undefined;
  constructor(fieldName: string, direction: 'ASC' | 'DESC' | undefined) {
    this.fieldName = fieldName;
    this.direction = direction;
  }
}
@Component({
  selector: 'app-billing-history',
  templateUrl: './billing-history.component.html',
  styleUrls: ['./billing-history.component.scss'],
  standalone: false,
})
export class BillingHistoryComponent implements OnInit {
  isLoading = true;
  loadHistory$;
  loadHistorySubs$;
  queryParametes = {};
  data: any;
  columns = historyColumns;

  sortByProp = 'eventDate';
  sortDirection: 'DESC' | 'ASC' | 1 | -1 | undefined = -1;
  freeSearchValue: string;
  recordsPerPage = 25;
  activePage = 1;
  totalPages = 1;
  resultsCount;

  constructor(
    private settingsSrv: SettingsService,
    private utilService: UtilService,
  ) {}

  ngOnInit(): void {
    this.getPagedRecords(0, 0);
  }

  createQueryParameters() {
    let searchCondition: string;
    if (this.freeSearchValue) {
      searchCondition = this.columns
        .filter((col) => col.searchable)
        .map((col) => col.prop + ` LIKE '%${this.freeSearchValue.trim()}%'`)
        .join(' OR ');
    }

    return {
      orderBy: this.sortByProp,
      orderDirection: this.sortDirection == -1 || this.sortDirection === 'DESC' ? 'DESC' : 'ASC',
      page: this.activePage - 1,
      recordsPerPage: this.recordsPerPage,
      where: searchCondition,
    };
  }

  async requestData(queryParams: any) {
    this.loadHistory$ = await this.settingsSrv.getPlanHistory(queryParams);
    this.loadHistorySubs$ = this.loadHistory$.subscribe((data) => {
      this.data = data?.results?.map((d) => {
        const record = new billingRecord(d);
        record.eventType = camelCaseToTitleCase(record.eventType);
        record.paymentStatus = camelCaseToTitleCase(record.paymentStatus);
        return record;
      });
      this.resultsCount = data?.count;
      this.totalPages = Math.ceil(data?.count / this.recordsPerPage);

      this.isLoading = false;
    });
  }

  getPagedRecords(page, maxsize): void {
    const queryParameters = this.createQueryParameters();
    this.requestData(queryParameters);
  }

  //UI events

  onFreeTextSearch(str: string) {
    if (this.freeSearchValue === str) return;
    this.freeSearchValue = str;
    this.getPagedRecords(this.activePage - 1, this.totalPages);
  }

  onSort(sortOption): void {
    this.sortByProp = sortOption.prop;
    this.sortDirection = sortOption.direction;

    this.getPagedRecords(0, this.recordsPerPage);
  }

  paginate(page: number): void {
    this.activePage = page + 1;
    this.getPagedRecords(page, this.recordsPerPage);
  }

  jumpToPage(page: number): void {
    if (!page) {
      alert('Please enter a valid number');
      return;
    }

    if (page > this.totalPages) {
      alert(`Please enter a Page no. less than ${this.totalPages}`);
      return;
    }

    this.activePage = page;
    this.getPagedRecords(this.activePage - 1, this.recordsPerPage);
  }

  changePerPage(newVal) {
    this.recordsPerPage = newVal;
    this.totalPages = Math.ceil(this.resultsCount / this.recordsPerPage);
    this.paginate(0);
  }
}
